import { ArticleImage } from './articleImage';
import TeaserPresenter from '../teaserPresenter';
import React from 'react';
import $ from 'jquery';

class ConsultantTeaser extends React.Component {
  constructor() {
    super();
    this.state = {
      teaser: TeaserPresenter.nullTeaser()
    };
  }

  componentDidMount() {
    this.ajaxTeaser();
  }

  correctConsultantTeaserHeight() {
    const $consultantTeaser = $('.consultant-teaser');
    const $consultantTeaserHeadlines = $consultantTeaser.find('> h4');
    const $consultantTeaserHeadlinesWithText = $consultantTeaser.find('> h4:not(:empty)');
    let maxHeight = 0;

    // only run this code if all teaser headlines have text rendered
    if ($consultantTeaserHeadlines.length == $consultantTeaserHeadlinesWithText.length) {
      $consultantTeaser.each(function determineMaxHeight() {
        // first reset all teaser heights possibly set before
        $(this).css('height', 'auto');

        // get default height of teaser headline
        const height = $(this).height();

        // check if height is greater than the max height, to determine a new max height
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // set max height for all teasers to be the same
      $consultantTeaser.height(maxHeight);
    }
  }

  ajaxTeaser() {
    const methods = [
      'title',
      'teaser',
      'public_url',
      'image_rechts_mobil_oben_teaser',
      'image_alt_rechts_mobil_oben',
      'consultant.function'
    ].join();

    $.ajax({
      url: `/api/v3/articles/${this.props.articleId}.json?methods=${methods}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ teaser: TeaserPresenter.getTeaser(data) }, function () {
            this.correctConsultantTeaserHeight();
          });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  render() {
    const { teaser = {} } = this.state;
    const { content, imageAlt, imageUrl, subtitle, title, urlName } = teaser;

    return (
      <div className="consultant-teaser">
        <a href={urlName} title={title}>
          <ArticleImage imageUrl={imageUrl} imageAlt={imageAlt} />

          <h3 className="margin-top-xxs no-margin-bottom">{title}</h3>
        </a>

        {!!subtitle && <h4 className="no-margin">{subtitle}</h4>}

        {!!content && <p>{content}</p>}
      </div>
    );
  }
}

ConsultantTeaser.propTypes = {
  articleId: React.PropTypes.number,
  parentArticleId: React.PropTypes.number
};

export default ConsultantTeaser;



// WEBPACK FOOTER //
// ./components/consultantTeaser.js